module.exports = __webpack_public_path__ + "static/media/29COICT12.b647624d.jpg";